var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFilter(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21363 13.1933C8.33841 13.1335 8.44358 13.0407 8.51723 12.9254C8.59088 12.8102 8.63007 12.6771 8.63037 12.5412V8.62114C8.63037 8.42809 8.70949 8.2424 8.85117 8.10535L13.4639 3.64447C13.7465 3.37109 13.9055 2.99972 13.9055 2.61288V0.729493C13.9051 0.633185 13.8853 0.537898 13.8472 0.449087C13.8091 0.360276 13.7535 0.279685 13.6835 0.211927C13.6135 0.144169 13.5305 0.0905747 13.4393 0.0542117C13.3481 0.0178488 13.2504 -0.000568737 13.1519 1.33801e-05H1.09442C0.677677 1.33801e-05 0.34082 0.3257 0.34082 0.729493V2.61288C0.34082 2.99972 0.499829 3.37109 0.782427 3.64447L5.39518 8.10535C5.46507 8.17275 5.52058 8.25305 5.55848 8.34159C5.59638 8.43014 5.61593 8.52515 5.61599 8.62114V13.2707C5.61599 13.8122 6.2053 14.1645 6.70644 13.922L8.21363 13.1933Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilter);
export default __webpack_public_path__ + "static/media/ic-filter.f6c74b6b.svg";
export { ForwardRef as ReactComponent };